import { render, staticRenderFns } from "./GestionCoordinadores.vue?vue&type=template&id=5ea75010&scoped=true"
import script from "./GestionCoordinadores.vue?vue&type=script&lang=js"
export * from "./GestionCoordinadores.vue?vue&type=script&lang=js"
import style0 from "./GestionCoordinadores.vue?vue&type=style&index=0&id=5ea75010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea75010",
  null
  
)

export default component.exports